<!-- <style>
    .sis-reports-header-icon {
        cursor: pointer;
    }


    .folderRow {
        background-color: #cfcfcf;
    }

    .tableOddRow {
        background-color: #F0F0F0;
        vertical-align: middle;
        width: 100%;
        height: 40px;
    }

    .tableOddRow:hover {
        background-color: #d7dab8;
    }

    .tableOddRow:focus {
        background-color: #d7dab8;
    }

    .tableEvenRow {
        background-color: White;
        vertical-align: middle;
        width: 100%;
        height: 40px;
    }

    .headerRow {
        font-weight: bold;
        display: table-header-group;
        background-color: #ffffff;
        height: 40px;
        padding-top: 5px;
        width: 100%;
    }

    .link {
        cursor: pointer;
        text-decoration: underline;
        /* text-wrap: none; */
        white-space: nowrap;
    }

    .link:hover {
        text-decoration: underline !important;
    }

    /* .sis-app-header {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        height: 65px;
        padding: 0px;
        background-color: #00366b;
        border-bottom: solid;
        border-bottom-color: #a9a9a9;
        border-bottom-width: 1px;
    } */

    .sis-header-icon {
        display: block;
        margin-left: auto;
        margin-right: auto;
        cursor: pointer;
    }

    /* .sis-app-content {
        position: absolute;
        top: 65px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        overflow: auto;
        padding: 15px;
    } */

    .sis-footer-customIcon {
        position: absolute;
        bottom: 2px;
        margin-right: 10px;
    }

    /* .sis-app-content-withfooter {
        position: absolute;
        top: 65px;
        left: 0px;
        right: 0px;
        bottom: 66px;
        overflow: auto;
        padding: 15px;
    } */

    .sis-app-content-reports {
        position: absolute;
        top: 65px;
        left: 0px;
        right: 0px;
        bottom: 30px;
        overflow: auto;
        padding: 15px;
    }

    .sis-reports-header {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        height: 65px;
        padding: 0px;
        background-color: #2f6326;
        border-bottom: solid;
        border-bottom-color: #a9a9a9;
        border-bottom-width: 1px;
    }
</style> -->







<!-- <reportHeader></reportHeader> -->

<!-- <mat-dialog-content> -->
<!-- 
        <tyl-form-field label="Code" style="width: 100%;"
        hint="{{200 - (tcSelectedRow.Code ? tcSelectedRow.Code.length : 0)}} characters left">
        <textarea matInput
            [(ngModel)]="tcSelectedRow.Code"
            maxlength="200"
            id="codeInput"
            name="Code"
            required
            rows="4">
        </textarea>
    </tyl-form-field> -->

<div id="divAllReports" style="height:100%; overflow:auto; background-color: #ffffff" class="sis-app-content-withfooter">

    <tyl-form-field label="Reports For">
        <mat-select id="reportsFor_ID" name="reportsFor" [(value)]="selectedReportModule" (selectionChange)="getReports(selectedReportModule);">
            <mat-option *ngFor="let reportModule of ReportModules" [value]="reportModule.ID">{{reportModule.Description}}</mat-option>
        </mat-select>
    </tyl-form-field>

    <!-- <div style="float:right">
        <table>
            <tr>
                <mat-cell>
                    &nbsp;
                </mat-cell>
                <mat-cell>
                     <input type="text" style="width:200px;" class="clearable" ngFocus="setSearchMessageVisible(true)"
                            ngBlur="setSearchMessageVisible(false)" [(ngModel)]="reportSearch" />&nbsp; -->
    <!-- 
                    <tyl-form-field label="Search" translate>
                        <input matInput [(ngModel)]="reportSearch" style="width:200px;" class="clearable" ngFocus="setSearchMessageVisible(true)"
                            ngBlur="setSearchMessageVisible(false)" />
                    </tyl-form-field>&nbsp;

                </mat-cell>
                <mat-cell>
                    <div (click)="searchReport()"><img src="./assets/images/search normal.png" style="width:25px;height:25px;" /></div>
                    <div (click)="clearSearchReport()"><img src="cancel.png" style="width:25px;height:25px;" /></div> -->
    <!-- </mat-cell>
            </tr>
            <tr>
                <mat-cell>
                    &nbsp;
                </mat-cell>
                <mat-cell colspan="2">
                     *ngIf="showSearchMessage"-->
    <!-- <span style="color:lightslategray;font-size:7pt;">Use % to
                        perform
                        wildcard
                        search.</span>
                </mat-cell>
            </tr>
        </table>
    </div>
    <div style="height:20px;">&nbsp;</div> -->
    <!-- <table class="table">
        <tr>
            <mat-cell style="padding-left:5px; font-weight:bold;">Name</mat-cell>
            <mat-cell style="padding-left:5px; font-weight:bold; text-align:center;">Type</mat-cell>
            <mat-cell style="padding-left:5px; font-weight:bold; text-align:center;" *ngIf="loginSettings.allowAutoRunReport">Auto-Run</mat-cell>
            <mat-cell style="padding-left:5px; font-weight:bold; text-align:center;">My Reports Folder</mat-cell>
            <mat-cell style="padding-right:10px; text-align:right; font-weight:bold;">Actions</mat-cell>
        </tr>
    </table> -->

    <tyl-form-field [clearable]="true" style="padding-left: 10px">
        <input matInput [ngModel]=filterValue (ngModelChange)="filterValue=$event; applyFilter(filterValue);"
            placeholder="Filter">
    </tyl-form-field>

    <div style="overflow:auto;">

        <div id="divReports">

            <!-- Angular Material table definition -->
            <mat-table #table [dataSource]="angularMatData" multiTemplateDataRows matSortDisableClear>
                <!-- Individual column definitions -->

                <ng-container matColumnDef="ReportName">
                    <mat-header-cell *matHeaderCellDef style="width:200px; padding-bottom: 12px; padding-left:5px; font-weight:bold;">Report
                        Name</mat-header-cell>
                    <mat-cell *matCellDef="let Report" style="width:200px; padding-left:5px;">
                        <a class="link" (click)="reportClicked(Report)">{{Report.Name}}</a>
                    </mat-cell>
                </ng-container>

                <!-- <ng-container matColumnDef="Type">
                    <mat-header-cell *matHeaderCellDef style="padding-bottom: 12px; padding-left:5px; font-weight:bold; text-align:center; ">Type</mat-header-cell>
                    <mat-cell *matCellDef="let Report" style="padding-left:5px;  text-align:center;">{{Report.Type}}</mat-cell>
                </ng-container> -->

                <ng-container matColumnDef="AutoRun">
                    <mat-header-cell *matHeaderCellDef style="width:120px; padding-bottom: 12px; padding-left:5px; font-weight:bold; text-align:center; ">
                        <span *ngIf="allowAutoRunReport">Auto-Run </span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Report" style="width:120px; padding-left:5px;  text-align:center;">
                        <span *ngIf="allowAutoRunReport && Report.AllowAutoRun">{{Report.AutoRun}} </span>
                    </mat-cell>

                </ng-container>

                <ng-container matColumnDef="MyReports">
                    <mat-header-cell *matHeaderCellDef style="padding-bottom: 12px; padding-left:5px; font-weight:bold; text-align:center; width:150px;">
                        <span *ngIf="allowAutoRunReport">My Reports Folder</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Report" style="padding-left:5px; width:150px; text-align:center; line-height:normal;">
                        <span *ngIf="allowAutoRunReport">{{Report.ReportFolder}} </span>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Actions">
                    <mat-header-cell *matHeaderCellDef style="padding-bottom: 12px; padding-right:10px; text-align:center; font-weight:bold; width:50px; justify-content: center;">Actions</mat-header-cell>
                    <mat-cell *matCellDef="let Report" style="text-align:center; width:50px; padding-right:10px;">
                        <!-- <a style="font-size:10pt;" class="link" (click)="reportSettingsClick(Report)">
                            <span>Settings</span></a> -->

                        <!-- new menu code -->

                        <div style="width:100%; text-align:center;">
                            <img [matMenuTriggerFor]="settingsMenu" yPosition="below" alt="Actions" src="./assets/images/actions.png"
                                style="height:30px; width:30px;" />
                        </div>
                        <mat-menu #settingsMenu="matMenu" [overlapTrigger]="false">
                            <div mat-menu-item style="line-height:normal;"(click)="reportSettingsClick(Report)">
                                <a style="font-size:10pt;cursor:pointer;" >
                                    <span>Folder Settings</span>
                                </a>
                            </div>
                            <div mat-menu-item style="line-height:normal;padding-top:5px;" (click)="autorunSettingsClick(Report)">
                                <a style="font-size:10pt;cursor:pointer;">
                                    <span>Auto-Run Settings</span>
                                </a>
                            </div>
                            <div *ngIf="useReportDefinitions" mat-menu-item style="line-height:normal;padding-top:5px;"(click)="reportOptionsClick(Report)">
                                <a style="font-size:10pt;cursor:pointer;" >
                                    <span>Report Options</span>
                                </a>
                            </div>
                        </mat-menu>
                    </mat-cell>
                </ng-container>

                <!-- Row definitions determine what will actually be displayed -->
                <ng-container>
                    <mat-header-row *matHeaderRowDef="columnsToDisplay;"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: columnsToDisplay; " tabindex="0">



                    </mat-row>
                </ng-container>


            </mat-table>
        </div>
    </div>

</div>
<!-- </mat-dialog-content> -->